// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-cf8d2336] {\n  height: calc(100vh - 166px);\n}\n.title[data-v-cf8d2336] {\n  font-size: 16px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
